module.exports = __webpack_public_path__ + "static/media/SummercampFestival2012SouvenirBandanaHanddrawn2colorscreenprint.1c49347d.webp";